import React from "react";

/**
 * Gold WinBizGrowth wordmark. Renders inline SVG so it stays crisp on every
 * viewport and needs no network round-trip.
 *
 * Sizes: sm (16 typography) / md (default 22) / lg (28).
 */
const SIZES = { sm: 16, md: 22, lg: 28 };

export function BrandLogo({ size = "md", className = "" }) {
  const px = SIZES[size] || SIZES.md;
  return (
    <span
      className={`inline-flex items-center gap-2 ${className}`}
      data-testid="brand-logo"
      aria-label="WinBizGrowth"
    >
      <svg
        viewBox="0 0 36 36"
        width={px + 6}
        height={px + 6}
        aria-hidden="true"
        role="img"
      >
        <defs>
          <linearGradient id="wbg-gold" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#FFD65B" />
            <stop offset="60%" stopColor="#FFC630" />
            <stop offset="100%" stopColor="#E9A800" />
          </linearGradient>
        </defs>
        <rect
          x="0.5"
          y="0.5"
          width="35"
          height="35"
          rx="9"
          ry="9"
          fill="#0F0F10"
          stroke="url(#wbg-gold)"
          strokeWidth="1.5"
        />
        <path
          d="M9 12.5 L14 24 L18 15 L22 24 L27 12.5"
          fill="none"
          stroke="url(#wbg-gold)"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span
        className="font-semibold tracking-tight text-brand-ink"
        style={{ fontSize: px, letterSpacing: "-0.02em" }}
      >
        WinBizGrowth
      </span>
    </span>
  );
}

export default BrandLogo;
